import { BannerConfig } from "@hub/models/ui/banner-config";
import { ThemeColors } from "@hub/values/theme-colors.enum";
import React from "react";
import styles from "./hero-banner.module.css";

export const HeroBanner: React.FC<BannerConfig> = ({
  title,
  description,
  withBorder,
}) => {
  const match = title.match(/([:?])/);
  const delimiter = match ? match[0] : "";

  const titleSections = title.split(/[:?]/);

  const preTitle = titleSections[0];
  const postTitle = titleSections[1];

  return (
    <div className={`${styles.banner} ${withBorder ? styles.withBorder : ""}`}>
      <div className={styles.banner__headline}>
        <h1 className={styles.banner__title}>
          <span className={styles.preTitle}>
            {preTitle}
            {postTitle ? delimiter : ""}
          </span>
          {postTitle && (
            <span
              className={`${styles.postTitle} ${styles[ThemeColors.INDIGO]}`}
            >
              {postTitle}
            </span>
          )}
        </h1>
        {description && (
          <span className={styles.banner__description}>{description}</span>
        )}
      </div>
    </div>
  );
};
